import ModalTextField from 'components/ModalTextField';
import CalculateIcon from 'assets/icons/calculate.svg';
import { CalculateFieldNames } from 'utils/constants/fieldNames';
import ButtonWithIcon from 'components/ButtonWithIcon';
import TextFieldLabel from 'components/ModalTextField/textFieldLabel';
import { GrowthAndRetentionSectionProps } from 'interfaces/components/dataEntryModal/GrowthAndRetentionSection';
import {
  expansionArrOfGrossNewField,
  grossDollarRetentionField,
  netDollarRetentionField,
  newLogoArrOfGrossNewField,
  newLogoVelocityField,
  quickRatioField
} from 'utils/constants/fields';

const GrowthAndRetentionSection = ({
  growthAndRetentionParentRef,
  growthAndRetentionRef,
  newLogoArrOfGrossNew,
  onNewLogoArrOfGrossNewChange,
  expansionArrOfGrossNew,
  onExpansionArrOfGrossNewChange,
  grossDollarRetention,
  onGrossDollarRetentionChange,
  netDollarRetention,
  onNetDollarRetentionChange,
  quickRatio,
  onQuickRatioChange,
  newLogoVelocity,
  onNewLogoVelocityChange,
  handleCalculateBtnClick
}: GrowthAndRetentionSectionProps) => {
  return (
    <div className='w-full' ref={growthAndRetentionParentRef}>
      <div
        className='w-full flex flex-col items-start gap-4 scroll-mt-3'
        ref={growthAndRetentionRef}
      >
        <p className='text-[24px] leading-[19.2px] font-light'>
          Growth and Retention
        </p>
        <div className='w-full grid grid-cols-2 gap-4 items-start'>
          <div className='col-span-2 flex flex-col items-start gap-4 p-4 border border-gray-400 dark:border-gray-800 rounded-lg'>
            <TextFieldLabel
              label='Gross New ARR Composition'
              tooltip='Enter the distribution of your new logo vs expansion ARR as a % of 100'
              name='gross_new_arr_composition'
              labelStyle='!text-[20px]'
            />
            <div className='w-full flex items-center justify-start gap-4'>
              <ModalTextField
                {...newLogoArrOfGrossNewField}
                value={newLogoArrOfGrossNew ? newLogoArrOfGrossNew : ''}
                onChange={onNewLogoArrOfGrossNewChange}
              />
              <ModalTextField
                {...expansionArrOfGrossNewField}
                value={expansionArrOfGrossNew ? expansionArrOfGrossNew : ''}
                onChange={onExpansionArrOfGrossNewChange}
              />
            </div>
            <ButtonWithIcon
              id='calculate_button'
              prefixIcon={CalculateIcon}
              prefixIconAlt='Calculate Icon'
              label='Calculate'
              className='w-full mr-2 bg-green-50 dark:text-black rounded-[4px] py-[6px] px-2 flex flex-row justify-center items-center cursor-pointer hover:bg-green-200 transition-all duration-300'
              textStyle='text-[14px] leading-[16px] font-semibold text-green-700'
              onClick={() =>
                handleCalculateBtnClick(
                  CalculateFieldNames.NEW_LOGO_ARR_OF_GROSS_NEW
                )
              }
            />
          </div>
          <ModalTextField
            {...grossDollarRetentionField}
            value={grossDollarRetention ? grossDollarRetention : ''}
            onChange={onGrossDollarRetentionChange}
            showCalculateBtn
            onCalculateBtnClick={() =>
              handleCalculateBtnClick(
                CalculateFieldNames.GROSS_DOLLAR_RETENTION
              )
            }
          />
          <ModalTextField
            {...netDollarRetentionField}
            value={netDollarRetention ? netDollarRetention : ''}
            onChange={onNetDollarRetentionChange}
            showCalculateBtn
            onCalculateBtnClick={() =>
              handleCalculateBtnClick(CalculateFieldNames.NET_DOLLAR_RETENTION)
            }
          />
          <ModalTextField
            {...quickRatioField}
            value={quickRatio ? quickRatio : ''}
            onChange={onQuickRatioChange}
            showCalculateBtn
            onCalculateBtnClick={() =>
              handleCalculateBtnClick(CalculateFieldNames.QUICK_RATIO)
            }
          />
          <ModalTextField
            {...newLogoVelocityField}
            value={newLogoVelocity ? newLogoVelocity : ''}
            onChange={onNewLogoVelocityChange}
          />
        </div>
      </div>
    </div>
  );
};

export default GrowthAndRetentionSection;
